import React, { useState, useEffect } from "react";
import Skeleton from "./Skeleton";
import { Helmet } from "react-helmet";
import "./IFrameComponent.css";

const IFrameComponent = ({ initialSrc, title }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Automatically set the src when the component mounts
    setIsLoading(true);
  }, []);

  return (
    <div className="iframe-container">
      <Helmet>
        <title>Listings in Salida, Buena Vista, and Colorado</title>
        <meta
          name="description"
          content="Explore active and pending residential property listings in Salida, Buena Vista, and nearby Colorado areas. Find your dream home today!"
        />
        <meta
          name="keywords"
          content="Salida real estate, Buena Vista properties, Colorado homes, residential listings, active homes, pending sales"
        />
      </Helmet>
      {isLoading && <Skeleton title={false} image={true} text={false} />}
      <iframe
        src="https://www.homesmartpreferredrealty.com/index.php?showagency=1&rtype=grid"
        title={title}
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setIsLoading(false);
          alert("Failed to load content");
        }}
        style={{ display: isLoading ? "none" : "block" }}
        width="100%"
        height="600px"
      />
    </div>
  );
};

export default IFrameComponent;
